import {
    gridPageCountSelector,
    useGridApiContext,
    useGridSelector,
    GridFooter,
} from '@mui/x-data-grid-pro'

function SkyBaseDataGridFooter({
    showAlways = false,
}: Readonly<{
    showAlways?: boolean,
}>) {
    const apiRef = useGridApiContext()
    const pageCount = useGridSelector(apiRef, gridPageCountSelector)

    if (pageCount <= 1 && !showAlways) {
        return null
    }

    return (
        <GridFooter />
    )
}

export default SkyBaseDataGridFooter
